import Layout from "./Layouts/index";
import NavigationScroll from "./Layouts/NavigationScroll";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClearAllField } from "./store/actions";
import { useLocation } from "react-router-dom";

function App() {
  const dispatch = useDispatch();
  const Locate = useLocation();
  const path = Locate.pathname;
  const { Personal } = useSelector((state) => state.payroll);

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  useEffect(() => {
    if (path !== "/add-employees") {
      if (Personal !== "") {
        dispatch(ClearAllField());
      }
    }
    // eslint-disable-next-line
  }, [path]);

  useEffect(() => {
    clearCacheData();
    localStorage.setItem("StateChange", true);
    // navigate('/', {replace:true})
    if (localStorage.getItem("StateChange") !== false) {
      localStorage.clear();
      localStorage.setItem("StateChange", false);
    }
  },[]);

  return (
    <>
      <NavigationScroll>
        <Layout />
      </NavigationScroll>
      <ToastContainer />
    </>
  );
}

export default App;
